import actionTypes from '../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RETAILER_DETAILS_SUCCESS:
      return { ...action.details };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/retailer-details.reducer.js